Logger.debug('script estandar loaded');



// WEBPACK FOOTER //
// ./src/scripts/estandar-script.js